// Localized structured content (brand data, manifesto, methodology, measures, dna)
const IMAGES = {
  gout: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  vetta: "/brand/vetta-hero.png",
  aura: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

const DATA = {
  es: {
    manifesto: [
      { no: "No diseñamos espacios.", si: "Diseñamos comportamiento." },
      { no: "No fabricamos muebles.", si: "Fabricamos experiencias." },
      { no: "No hacemos proyectos.", si: "Creamos plataformas." },
      { no: "No seguimos tendencias.", si: "Las creamos." },
    ],
    methodology: [
      { n: "01", title: "Escuchar", text: "Comprender el ADN, necesidades y objetivos estratégicos." },
      { n: "02", title: "Pensar", text: "Inteligencia estratégica y conceptualización del sistema." },
      { n: "03", title: "Diseñar", text: "Creación de la arquitectura, interiores y experiencias." },
      { n: "04", title: "Fabricar", text: "Producción propia y control de manufactura integral." },
      { n: "05", title: "Implementar", text: "Ejecución técnica, logística y montaje de precisión." },
      { n: "06", title: "Acompañar", text: "Operación, análisis de datos y evolución continua." },
    ],
    measures: [
      { n: "01", title: "Flujo", tag: "FLOW ANALYTICS", text: "Por dónde se mueve la gente y qué rutas toma en el espacio." },
      { n: "02", title: "Permanencia", tag: "DWELL TIME", text: "Cuánto tiempo pasa en cada zona. El dwell time como proxy de valor." },
      { n: "03", title: "Interacción", tag: "TOUCH RATE", text: "Qué toca, qué mira y qué evita. El comportamiento real del usuario." },
      { n: "04", title: "Conversión", tag: "CONVERSION RATE", text: "Qué recorrido termina en compra, reserva o acción concreta." },
      { n: "05", title: "Rentabilidad", tag: "REVENUE / M²", text: "Qué zonas generan valor económico real por metro cuadrado." },
    ],
    dna: ["Diseño", "Datos", "Tecnología", "Manufactura", "Retail", "Experiencia", "Contenido", "Operación", "Escalabilidad", "IA", "Automatización"],
    brands: {
      gout: {
        role: "Consultoría · Arquitectura · Interiorismo",
        description: "La unidad de consultoría estratégica que redefine el espacio. No diseñamos entornos; orquestamos inteligencia aplicada a sectores de alto impacto.",
        capabilities: [
          { title: "Arquitectura", text: "Sistemas estructurales y visión de autor para proyectos de gran escala." },
          { title: "Corporate", text: "Diseño de cultura y productividad mediante entornos de trabajo inteligentes." },
          { title: "Hospitality", text: "Experiencias inmersivas de lujo diseñadas para la hospitalidad global." },
          { title: "Retail", text: "Plataformas comerciales que convierten el flujo en rentabilidad medible." },
          { title: "Residential", text: "Living Intelligence aplicada a la forma en que se habita el mundo." },
        ],
      },
      vetta: {
        role: "From Design to Market",
        description: "No es un suministrador; es una plataforma de inteligencia operativa que integra la cadena de valor completa, del diseño al mercado.",
        capabilities: [
          { title: "Desarrollo & Ingeniería", text: "Product development e ingeniería de producto a escala." },
          { title: "Manufactura", text: "Producción propia y control total de calidad." },
          { title: "Importaciones", text: "Operaciones internacionales sin fricciones, de origen a destino." },
          { title: "Distribución", text: "Logística inteligente y gestión global de activos." },
          { title: "Marketplace", text: "Ecosistema digital, private label y licencias de propiedad intelectual." },
        ],
      },
      aura: {
        role: "Life Design Brand",
        description: "La inteligencia emocional del ecosistema. No vendemos productos: creamos estilos de vida y diseñamos la forma en que se habita el mundo.",
        capabilities: [
          { title: "Lifestyle", text: "La curaduría de la cotidianidad. Sistemas de vida con identidad y propósito." },
          { title: "Decoración", text: "Estética con intención. Armonización de espacios por inteligencia visual." },
          { title: "Objetos", text: "Piezas exclusivas con alma arquitectónica bajo Material Intelligence." },
          { title: "Colecciones", text: "Moodboards, espacios y emociones que definen el universo visual." },
          { title: "E-commerce", text: "Comercio premium, comunidad y programa Trade para diseñadores." },
        ],
      },
    },
  },
  en: {
    manifesto: [
      { no: "We don't design spaces.", si: "We design behavior." },
      { no: "We don't make furniture.", si: "We craft experiences." },
      { no: "We don't do projects.", si: "We build platforms." },
      { no: "We don't follow trends.", si: "We create them." },
    ],
    methodology: [
      { n: "01", title: "Listen", text: "Understand the DNA, needs and strategic objectives." },
      { n: "02", title: "Think", text: "Strategic intelligence and system conceptualization." },
      { n: "03", title: "Design", text: "Creation of architecture, interiors and experiences." },
      { n: "04", title: "Manufacture", text: "In-house production and integral manufacturing control." },
      { n: "05", title: "Implement", text: "Technical execution, logistics and precision assembly." },
      { n: "06", title: "Accompany", text: "Operation, data analysis and continuous evolution." },
    ],
    measures: [
      { n: "01", title: "Flow", tag: "FLOW ANALYTICS", text: "Where people move and which routes they take across the space." },
      { n: "02", title: "Dwell", tag: "DWELL TIME", text: "How long they spend in each zone. Dwell time as a proxy for value." },
      { n: "03", title: "Interaction", tag: "TOUCH RATE", text: "What they touch, look at and avoid. Real user behavior." },
      { n: "04", title: "Conversion", tag: "CONVERSION RATE", text: "Which journey ends in a purchase, booking or concrete action." },
      { n: "05", title: "Profitability", tag: "REVENUE / M²", text: "Which zones generate real economic value per square meter." },
    ],
    dna: ["Design", "Data", "Technology", "Manufacturing", "Retail", "Experience", "Content", "Operations", "Scalability", "AI", "Automation"],
    brands: {
      gout: {
        role: "Consulting · Architecture · Interiors",
        description: "The strategic consulting unit that redefines space. We don't design environments; we orchestrate intelligence applied to high-impact sectors.",
        capabilities: [
          { title: "Architecture", text: "Structural systems and authorial vision for large-scale projects." },
          { title: "Corporate", text: "Culture and productivity design through intelligent workplaces." },
          { title: "Hospitality", text: "Immersive luxury experiences designed for global hospitality." },
          { title: "Retail", text: "Commercial platforms that turn flow into measurable profitability." },
          { title: "Residential", text: "Living Intelligence applied to the way the world is inhabited." },
        ],
      },
      vetta: {
        role: "From Design to Market",
        description: "Not a supplier; an operational intelligence platform that integrates the entire value chain, from design to market.",
        capabilities: [
          { title: "Development & Engineering", text: "Product development and product engineering at scale." },
          { title: "Manufacturing", text: "In-house production and total quality control." },
          { title: "Imports", text: "Frictionless international operations, from origin to destination." },
          { title: "Distribution", text: "Intelligent logistics and global asset management." },
          { title: "Marketplace", text: "Digital ecosystem, private label and intellectual property licensing." },
        ],
      },
      aura: {
        role: "Life Design Brand",
        description: "The emotional intelligence of the ecosystem. We don't sell products: we create lifestyles and design the way the world is inhabited.",
        capabilities: [
          { title: "Lifestyle", text: "The curation of everyday life. Living systems with identity and purpose." },
          { title: "Decor", text: "Aesthetics with intention. Harmonizing spaces through visual intelligence." },
          { title: "Objects", text: "Exclusive pieces with architectural soul under Material Intelligence." },
          { title: "Collections", text: "Moodboards, spaces and emotions that define the visual universe." },
          { title: "E-commerce", text: "Premium commerce, community and a Trade program for designers." },
        ],
      },
    },
  },
};

const NAMES = {
  gout: { name: "GOÛT", tagline: "Design Intelligence Studio", accent: "#0A1428", logo: "/brand/logo3.png" },
  vetta: { name: "VETTA", tagline: "Product Intelligence Platform", accent: "#1A2438", logo: "/brand/logo2.png" },
  aura: { name: "AURA", tagline: "Living Intelligence", accent: "#C9A24B", logo: "/brand/logo4.png" },
};

export function getContent(lang) {
  const d = DATA[lang] || DATA.es;
  const brands = {};
  ["gout", "vetta", "aura"].forEach((k) => {
    brands[k] = { key: k, ...NAMES[k], image: IMAGES[k], ...d.brands[k] };
  });
  return { manifesto: d.manifesto, methodology: d.methodology, measures: d.measures, dna: d.dna, brands };
}
